import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';
import { Bell, CheckCheck, Trash2, ExternalLink } from 'lucide-react';

const typeIcon = {
  task_assigned: 'Task',
  comment_added: 'Comment',
  task_moved: 'Update',
  project_updated: 'Project',
};

const timeAgo = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'Just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
};

const Notifications = () => {
  const navigate = useNavigate();
  const { notifications, unreadCount, markRead, markAllRead, deleteNotification, clearAll } = useNotifications();

  const handleClick = async (n) => {
    if (!n.isRead) await markRead(n.id);
    if (n.link) navigate(n.link);
  };

  return (
    <div className="page-content">
      <div className="flex-between mb-24">
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Notifications</h1>
          <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 2 }}>
            {unreadCount > 0 ? `${unreadCount} unread` : 'All caught up!'}
          </p>
        </div>
        {notifications.length > 0 && (
          <div style={{ display: 'flex', gap: 8 }}>
            {unreadCount > 0 && (
              <button className="btn btn-secondary btn-sm" onClick={markAllRead}>
                <CheckCheck size={14} /> Mark all read
              </button>
            )}
            <button className="btn btn-secondary btn-sm" onClick={() => { if (window.confirm('Clear all notifications?')) clearAll(); }}
              style={{ color: '#ef4444' }}>
              <Trash2 size={14} /> Clear all
            </button>
          </div>
        )}
      </div>

      {!notifications.length ? (
        <div className="empty-state">
          <Bell size={48} />
          <p>No notifications yet</p>
          <p style={{ fontSize: 13, marginTop: 8 }}>You'll be notified when tasks are assigned or commented on</p>
        </div>
      ) : (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {notifications.map(n => (
            <div key={n.id} className={`notif-item${!n.isRead ? ' unread' : ''}`} onClick={() => handleClick(n)}>
              <div className={`notif-dot${n.isRead ? ' read' : ''}`} style={{ marginTop: 8 }} />
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 16 }}>{typeIcon[n.type] || 'Notice'}</span>
                  <div className="notif-title">{n.title}</div>
                  {n.link && <ExternalLink size={12} style={{ color: 'var(--text-muted)', marginLeft: 'auto', flexShrink: 0 }} />}
                </div>
                <div className="notif-msg">{n.message}</div>
                <div className="notif-time">{timeAgo(n.createdAt)}</div>
              </div>
              <button onClick={e => { e.stopPropagation(); deleteNotification(n.id); }}
                title="Delete"
                style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', padding: '4px', opacity: 0.6, flexShrink: 0, alignSelf: 'flex-start', marginTop: 4 }}>
                <Trash2 size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notifications;

